import axios, { AxiosResponse, AxiosError } from 'axios';
import NoviLogging from "@/common/services/NoviLogging";
import { INoviNsPaymentGlobals } from '../../common/types/Payment/NoviNsPaymentGlobals';

declare let noviNs: INoviNsPaymentGlobals;

class QuickbooksPaymentsRepo {
    getQuickbooksPaymentToken(card: any) {
        const tokenizeUrl = noviNs.quickbooksPaymentsUrl + 'tokens';

        return axios.post<{ value: string }>(tokenizeUrl, card)
            .then((axiosResponse: AxiosResponse<{ value: string }>) => {
                return axiosResponse.data.value;
            })
            .catch((axiosError: AxiosError) => {
                // PCI: never log the request body — it contains the PAN/CVV (or ACH
                // account/routing numbers). Only transport-level metadata is safe, and it
                // is what we need to tell a network/CORS/CSP/DNS failure (no response)
                // apart from an HTTP error returned by QuickBooks Payments.
                NoviLogging.error('QuickBooks Payments tokenize request failed', {
                    url: tokenizeUrl,
                    quickbooksPaymentsUrlConfigured: !!noviNs.quickbooksPaymentsUrl,
                    message: axiosError?.message,
                    code: axiosError?.code,
                    hasResponse: !!axiosError?.response,
                    httpStatus: axiosError?.response?.status ?? null,
                    responseData: axiosError?.response?.data ?? null,
                });
                throw axiosError;
            });
    }
}

export const qbPaymentsRepo = new QuickbooksPaymentsRepo();